import BaseModel from "./BaseModel";
import Requests from "./Requests";
import User from "./User";
export default class UserSubscriptions extends BaseModel {
  static entity = "UserSubscriptions";
  static primaryKey = "id";
  static validStates = [
    "incomplete",
    "trialing",
    "active",
    "past_due",
    "unpaid",
    "paused",
  ];
  static invalidStates = ["legacy_canceled", "incomplete_expired", "canceled"];

  static fields() {
    return {
      id: this.attr(null),
      pricing_rule_id: this.attr(null),
      payment_method_id: this.attr(null),
      state: this.attr(""),
      activated_at: this.attr(""),
      canceled_at: this.attr(""),
      current_period_ends_at: this.attr(""),
      sub_type: this.attr(""),
      company_id: this.attr(null),
    };
  }

  static async fetchAll() {
    const { data } = await this.axios.get(`/subscriptions`);
    Requests.markAsLoaded("UserSubscriptions");
    await this.create({ data });
  }

  static async startSubscription(params) {
    const response = await this.axios.post(`/subscriptions`, params);
    await Requests.markAsNotLoaded("UserSubscriptions");
    return response;
  }

  static async updatePlan(subscriptionId, newPlan) {
    await this.axios.patch(`/subscriptions/${subscriptionId}`, {
      pricing_rule_id: newPlan.pricing_rule_id,
    });
    Requests.markAsNotLoaded("UserSubscriptions");
    this.fetchAll();
  }

  static async updateCard(id, newCard) {
    await this.axios.patch(`/subscriptions/${id}`, {
      payment_method_id: newCard,
    });
    Requests.markAsNotLoaded("UserSubscriptions");
    this.fetchAll();
  }

  static async cancel(id) {
    const response = await this.axios.delete(`/subscriptions/${id}`);
    await this.fetchAll();
    await User.getProfile();
    return response;
  }

  isActive() {
    return UserSubscriptions.validStates.includes(this.state);
  }
  isInactive() {
    return UserSubscriptions.invalidStates.includes(this.state);
  }
}
